import type {
    BadgeTone,
    OrderStatus,
    PaymentMethod,
    PaymentStatus,
    SiteConfig
} from '@/types'

import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'سایه',
    latinName: 'SAYEH',
    description: 'سایه، فروشگاه آنلاین پوشاک و اکسسوری مینیمال. لباس‌های ساده، خوش‌دوخت و ماندگار با ارسال به سراسر ایران و امکان پرداخت در محل.',
    tagline: 'ساده بپوش، ماندگار بمان',
    url: getOrigin()
}

export const STORE_NAV = [
    { label: 'فروشگاه', href: '/shop' },
    { label: 'تازه‌ها', href: '/shop?sort=newest' },
    { label: 'تخفیف‌دارها', href: '/shop?sale=1' },
    { label: 'راهنمای خرید', href: '/help' }
]

export const SHOP_PAGE_SIZE = 12
export const ADMIN_PAGE_SIZE = 20
export const LOW_STOCK_THRESHOLD = 3
export const MAX_ITEM_QUANTITY = 10
export const MAX_CART_LINES = 20
export const MIN_PASSWORD_LENGTH = 6

export const ORDER_STATUS_META: Record<OrderStatus, { label: string, tone: BadgeTone, description: string }> = {
    pending: { label: 'در انتظار تأیید', tone: 'warning', description: 'سفارش ثبت شده و منتظر بررسی فروشگاه است.' },
    processing: { label: 'در حال آماده‌سازی', tone: 'info', description: 'سفارش تأیید شده و در حال بسته‌بندی است.' },
    shipped: { label: 'ارسال شده', tone: 'default', description: 'سفارش تحویل پست شده و در راه است.' },
    delivered: { label: 'تحویل شده', tone: 'success', description: 'سفارش به دست شما رسیده است.' },
    cancelled: { label: 'لغو شده', tone: 'destructive', description: 'این سفارش لغو شده است.' }
}

export const ORDER_FLOW: Array<OrderStatus> = ['pending', 'processing', 'shipped', 'delivered']

export const ORDER_STATUSES: Array<OrderStatus> = ['pending', 'processing', 'shipped', 'delivered', 'cancelled']

export const PAYMENT_STATUS_META: Record<PaymentStatus, { label: string, tone: BadgeTone }> = {
    unpaid: { label: 'پرداخت نشده', tone: 'warning' },
    paid: { label: 'پرداخت شده', tone: 'success' },
    refunded: { label: 'مسترد شده', tone: 'secondary' }
}

export const PAYMENT_STATUSES: Array<PaymentStatus> = ['unpaid', 'paid', 'refunded']

export const PAYMENT_METHOD_META: Record<PaymentMethod, { label: string, description: string }> = {
    cod: { label: 'پرداخت در محل', description: 'مبلغ سفارش را هنگام تحویل به مأمور پست پرداخت کنید.' },
    card: { label: 'کارت به کارت', description: 'پس از ثبت سفارش، مبلغ را به شماره کارت فروشگاه واریز کنید.' }
}

export const SORT_OPTIONS = [
    { value: 'newest', label: 'جدیدترین' },
    { value: 'popular', label: 'پرفروش‌ترین' },
    { value: 'price-asc', label: 'ارزان‌ترین' },
    { value: 'price-desc', label: 'گران‌ترین' }
] as const

export type SortOption = typeof SORT_OPTIONS[number]['value']

export const PROVINCES = [
    'آذربایجان شرقی',
    'آذربایجان غربی',
    'اردبیل',
    'اصفهان',
    'البرز',
    'ایلام',
    'بوشهر',
    'تهران',
    'چهارمحال و بختیاری',
    'خراسان جنوبی',
    'خراسان رضوی',
    'خراسان شمالی',
    'خوزستان',
    'زنجان',
    'سمنان',
    'سیستان و بلوچستان',
    'فارس',
    'قزوین',
    'قم',
    'کردستان',
    'کرمان',
    'کرمانشاه',
    'کهگیلویه و بویراحمد',
    'گلستان',
    'گیلان',
    'لرستان',
    'مازندران',
    'مرکزی',
    'هرمزگان',
    'همدان',
    'یزد'
]

export const COLOR_SWATCHES: Record<string, string> = {
    'مشکی': '#151515',
    'سفید': '#ffffff',
    'کرم': '#efe6d2',
    'بژ': '#d8c4a4',
    'استخوانی': '#f1ebdd',
    'طوسی': '#9b9a96',
    'خاکستری': '#8a8a8a',
    'نقره‌ای': '#c4c4c4',
    'سرمه‌ای': '#1f2a44',
    'آبی': '#3f5f8f',
    'آبی روشن': '#a3bcd4',
    'قهوه‌ای': '#6b4a33',
    'شتری': '#b8865b',
    'سبز زیتونی': '#6b6b3a',
    'سبز': '#3e6b4f',
    'قرمز': '#a3302b',
    'زرشکی': '#6e1f2a',
    'صورتی': '#e7b8b8',
    'یاسی': '#b9a6c9',
    'نارنجی': '#d9772b',
    'زرد': '#e5c350',
    'طلایی': '#c9a54c'
}

export const SIZE_SUGGESTIONS = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '36', '38', '40', '42', '44', '46', 'فری‌سایز']

export const COLOR_SUGGESTIONS = Object.keys(COLOR_SWATCHES)
